import React from 'react';
import { Link } from 'react-router-dom';
import { FONTS } from '../brand/theme';
import { Logo } from '../brand/Logo';

const S = {
  page:  { minHeight: '100vh', background: '#F8FAFC', fontFamily: FONTS.body, color: '#0F172A' },
  nav:   { background: '#fff', borderBottom: '1px solid #E2E8F0', padding: '14px 24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' },
  wrap:  { maxWidth: 740, margin: '0 auto', padding: '52px 24px 80px' },
  h1:    { fontFamily: FONTS.display, fontSize: 34, fontWeight: 700, color: '#0F172A', marginBottom: 6, letterSpacing: '-0.02em' },
  meta:  { fontSize: 13.5, color: '#64748B', marginBottom: 44 },
  h2:    { fontFamily: FONTS.display, fontSize: 19, fontWeight: 700, color: '#0F172A', margin: '38px 0 10px', letterSpacing: '-0.01em' },
  p:     { fontSize: 14.5, lineHeight: 1.75, color: '#334155', marginBottom: 14 },
  ul:    { fontSize: 14.5, lineHeight: 1.75, color: '#334155', paddingLeft: 22, marginBottom: 14 },
  hr:    { border: 'none', borderTop: '1px solid #E2E8F0', margin: '40px 0' },
  badge: { display: 'inline-block', background: 'rgba(16,185,129,0.1)', color: '#059669', border: '1px solid rgba(16,185,129,0.2)', borderRadius: 6, padding: '3px 10px', fontSize: 12, fontWeight: 600, marginBottom: 24 },
  warn:  { background: '#FFF7ED', border: '1px solid #FED7AA', borderRadius: 10, padding: '14px 18px', marginBottom: 28, fontSize: 14, color: '#9A3412', lineHeight: 1.65 },
};

export default function TermsPage() {
  return (
    <div className="koala-page" style={S.page}>
      <nav style={S.nav}>
        <Link to="/" style={{ textDecoration: 'none' }}><Logo size={38} /></Link>
        <Link to="/" style={{ fontFamily: FONTS.body, fontSize: 13, color: '#64748B', textDecoration: 'none' }}>← Back to home</Link>
      </nav>

      <main style={S.wrap}>
        <div style={S.badge}>Legal</div>
        <h1 style={S.h1}>Terms of Service</h1>
        <p style={S.meta}>Effective date: June 2026 · Last updated: June 2026</p>
        <hr style={S.hr} />

        <div style={S.warn}>
          <strong>Not financial advice.</strong> Koala Statements is a financial modeling tool, not a financial advisor. Nothing produced by this software constitutes investment, legal, tax, or accounting advice. Always consult qualified professionals before making financial decisions.
        </div>

        <p style={S.p}>By accessing or using Koala Statements ("the Service"), you agree to be bound by these Terms of Service ("Terms"). If you do not agree, do not use the Service.</p>

        <h2 style={S.h2}>1. The Service</h2>
        <p style={S.p}>Koala Statements provides a web-based financial modeling platform that allows users to create, edit, and share 3-statement financial models. Features include an AI-powered model generation assistant, multi-scenario modeling, and investor-ready report export.</p>

        <h2 style={S.h2}>2. Accounts</h2>
        <p style={S.p}>You must provide accurate information when creating an account. You are responsible for maintaining the security of your credentials. You must be 18 years or older to use the Service. We may suspend accounts that violate these Terms.</p>

        <h2 style={S.h2}>3. Your content and IP</h2>
        <p style={S.p}>You retain full ownership of the financial models and data you create. By using the Service you grant us a limited license to store and process that data solely to provide the Service. We do not claim ownership of your work and do not use your model data to train AI systems.</p>

        <h2 style={S.h2}>4. Acceptable use</h2>
        <p style={S.p}>You agree not to:</p>
        <ul style={S.ul}>
          <li>Use the Service for any unlawful purpose or to violate any regulation</li>
          <li>Attempt to reverse-engineer, scrape, or copy the Service</li>
          <li>Attempt to gain unauthorized access to other users' data</li>
          <li>Send spam or abuse the AI advisor endpoint</li>
          <li>Use the Service to create fraudulent financial projections intended to deceive investors</li>
        </ul>

        <h2 style={S.h2}>5. Not financial advice</h2>
        <p style={S.p}>The financial models generated by Koala Statements are illustrative projections based on assumptions you provide. They are tools for planning and exploration, not guaranteed forecasts. We make no representations about the accuracy or completeness of any model output. Nothing in the Service should be construed as investment, financial, legal, or tax advice.</p>
        <p style={S.p}><strong>You bear full responsibility for any financial decisions made based on outputs from this tool.</strong></p>

        <h2 style={S.h2}>6. AI-generated content</h2>
        <p style={S.p}>The AI advisor generates suggestions based on your inputs using third-party AI models (Google Gemini). AI-generated content may contain errors, omissions, or unrealistic assumptions. You are responsible for reviewing and validating all AI-generated content before relying on it.</p>

        <h2 style={S.h2}>7. Availability and modifications</h2>
        <p style={S.p}>We provide the Service on an "as is" and "as available" basis. We may modify, suspend, or discontinue any feature at any time with reasonable notice. We will make reasonable efforts to notify you of significant changes via email or in-app notice.</p>

        <h2 style={S.h2}>8. Disclaimer of warranties</h2>
        <p style={S.p}>To the fullest extent permitted by law, we disclaim all warranties, express or implied, including merchantability, fitness for a particular purpose, and non-infringement. We do not warrant that the Service will be uninterrupted, error-free, or completely secure.</p>

        <h2 style={S.h2}>9. Limitation of liability</h2>
        <p style={S.p}>To the maximum extent permitted by law, Koala Statements will not be liable for indirect, incidental, special, consequential, or punitive damages, including lost profits, arising from your use of the Service. Our total liability for any claim shall not exceed the amount you paid us in the 12 months prior to the claim.</p>

        <h2 style={S.h2}>10. Termination</h2>
        <p style={S.p}>You may close your account at any time. We may terminate or suspend access to the Service for violations of these Terms, with or without notice. Upon termination, your data will be deleted per our Privacy Policy.</p>

        <h2 style={S.h2}>11. Governing law</h2>
        <p style={S.p}>These Terms are governed by the laws of the State of Delaware, United States, without regard to conflict of law principles.</p>

        <h2 style={S.h2}>12. Changes to these Terms</h2>
        <p style={S.p}>We may update these Terms from time to time. Continued use of the Service after changes constitutes acceptance. We will notify you of material changes via email or in-app notice at least 14 days in advance.</p>

        <hr style={S.hr} />
        <p style={{ ...S.p, color: '#64748B' }}>Questions? Reach us anytime through the <Link to="/#contact" style={{ color: '#047857' }}>contact form</Link> on our website.</p>
      </main>
    </div>
  );
}
